// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2zZNO","content":"Consent_content__1YExf","footer":"Consent_footer__38b4e"};